import React from "react";

import { Box, Grid } from "@mui/material";

import { getSession } from "../../auth";
import api from '../../api';

import ConversationList from "./ConversationList";
import MessagesArea from "./MessagesArea";
import Profile from "./Profile";
import ChatRightSideBar from "./ChatRightSideBar";

import ModalMessagesArea from "../ManageCalls/MessagesArea";
import HistoryMessagesDialog from "../Dialogs/HistoryMessagesDialog";
import WebphoneMenu from "../Menu/WebphoneMenu";

import useNotification from "../Notification";
import ErrorBoundary from "../ErrorBoundary"
import { ReactNotifications } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import 'animate.css/animate.min.css';
import NewConversationList from "./NewConversationList";
import { CircularProgress } from "@mui/material";

import "./styles.css";
import isMobile from "../../utils/isMobile";
import UserPermissions from "../User/Permissions";
import { setFaviconBadge } from '../../utils/favicon';

import { MenuContext } from "../../contexts/MenuContext"

// Breakpoint for switching between column and overlay mode
const OVERLAY_MODE_BREAKPOINT = 1440;

class Chat extends React.Component {
    static contextType = MenuContext

    constructor(props) {

        super(props);

        this.state = {
            activeTab            : 1,
            activeSubTab         : 0,
            showProfile          : false,
            contactData          : {},
            activeVoice          : {},
            enterpriseId         : null,
            enterpriseQueues     : [],
            userId               : null,
            agentId              : null,
            agentUser            : null,
            predefinedMessages   : [],
            accountcode          : null,
            socket               : null,
            socketVoice          : null,
            showChatHistory      : false,
            historyChat          : null,
            historyMessages      : [],
            uniqueId             : null,
            lastDateTime         : null,
            platform             : null,
            nameChangeField      : false,
            emailChangeField     : false,
            renderKey            : 0,
            templates            : [],
            showModal            : false,
            notificationAudio    : '',
            renderKeyList        : 0,
            refresh              : false,
            loading              : false,
            showChatRightSideBar : false,
            allLabels            : [],
            allGroups            : [],
            chatLabels           : [],
            chatGroups           : [],
            ready                : false,
            updateList           : false,
            callMessage          : '',
            chatCursor           : 0,
            profileContent       : null,
            isOverlayMode        : false,
            chatListLastMessage  : null
        }

        this.agentCanUpdateContact = true;
        this.messageArea = null;

    }

    fetchTemplates = async () => {
        await api.get(`/api/enterprises/${this.state.enterpriseId}/templates/`)
            .then((res) => {
                if (res.status == 200) {
                    if (getSession().profile.enterprise.abstraction_layer) {
                        let templates = {}
                        Object.keys(res.data).forEach((key) => {
                            res.data[key].waba_templates = res.data[key].waba_templates.filter((template) => {
                                return (template.status == 'approved' &&
                                    template.language == 'pt_BR' &&
                                    !template.name.includes('sample_'));
                            });
                            templates[key] = res.data[key].waba_templates
                        })
                        this.state.templates = templates;   
                    } else {
                        let templates = res.data.waba_templates.filter((template) => {
                            return (template.status == 'approved' &&
                                template.language == 'pt_BR' &&
                                !template.name.includes('sample_'));
                        });
                        this.state.templates = templates;   
                    }
                    return;
                }
                throw res;
            })
            .catch((err) => {
                console.error(err);
            });
    }

    // Detects if device is on iOS 
    isIos = () => {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test(userAgent);
    }

    fetchEnterprise = async () => {
        await api.get(`/api/enterprises/${this.state.enterpriseId}/`)
            .then((res) => {
                if (res.status == 200) {
                    if (res.data.settings) {
                        const settings = res.data.settings;
                        this.agentCanUpdateContact = settings.agent_can_update_contact;

                        this.setState({
                            notificationAudio: res.data.audio_notification,
                            renderKeyList: Math.random()
                        });
                    }

                    if ("Notification" in window) {
                        // I have permission to receive notification
                        if (Notification.permission === "granted") {
                            if (this.isIos()) {
                                useNotification(
                                    'Informação útil!',
                                    'Identificamos que você está em um navegador iOS, as notificações de novas mensagens não estão disponíveis por restrição do Sistema Operacional.',
                                    'info'
                                );
                            }
                        } else {
                            if (this.isIos()) {
                                useNotification(
                                    'Informação útil!',
                                    'Identificamos que você está em um navegador iOS, as notificações de novas mensagens não estão disponíveis por restrição do Sistema Operacional.',
                                    'info'
                                );
                            }
                            else {
                                useNotification(
                                    'Atenção!',
                                    'Mantenha as notificações ativas no seu navegador para sempre ser informado de uma nova mensagem no seu Kwik.',
                                    'warning'
                                );
                            }
                        }
                    }
                    
                    this.state.enterpriseId = res.data.id;
                    this.state.accountcode = res.data.accountcode;

                    const queue_transfer = api.get(`/api/enterprises/${this.state.enterpriseId}/get_queues/`)
                    .then((res) => {
                        this.state.enterpriseQueues = res.data;
                    }).catch((error) => {
                        console.log(error)
                    });

                    return;
                }
                throw res;
            })
            .catch((error) => {
                console.error(error);
            }); 
    }

    fetchPredefinedMessages = async () => {
        const ent_mes = api.get(`/api/enterprises/${this.state.enterpriseId}/predefinedmessages/`)
        const usr_mes = api.get(`/api/users/${this.state.userId}/predefinedmessages/`)

        const [ent_res, usr_res] = await Promise.all([ent_mes, usr_mes])
        let predefinedData = {}

        if (usr_res.status == 200) {
            predefinedData = { ...predefinedData, ...usr_res.data }
        }
        else {
            console.error(usr_res.err);
        }

        if (ent_res.status == 200) {
            ent_res.data.map(each => {
                const cat = `${each.category} - Geral`
                if (cat in predefinedData)
                    predefinedData[cat].push({
                        id: each.id,
                        message: each.message,
                        queue_id: each.queue_id,
                        queue_ids: each.queue_ids
                    })
                else
                    predefinedData[cat] = [{
                        id: each.id,
                        message: each.message,
                        queue_id: each.queue_id,
                        queue_ids: each.queue_ids
                    }]
            })
        }
        else {
            console.error(usr_res.err);
        }

        this.setState({ predefinedMessages: predefinedData })
    }

    addPredefinedMessage = async (message, category, queue=0) => {
        let data = null;
        const queueSelection = Array.isArray(queue)
            ? queue
            : (queue && typeof queue === 'object' && Array.isArray(queue.queue_ids))
                ? queue.queue_ids
                : [queue && typeof queue === 'object' ? queue.queue_id : queue];
        const normalizedQueueIds = [...new Set(
            queueSelection
                .map((value) => Number(value))
                .filter((value) => !Number.isNaN(value) && value > 0)
        )];
        const payload = {
            message: message,
            category: category,
            queue_ids: normalizedQueueIds,
            queues: normalizedQueueIds
        };

        if (normalizedQueueIds.length === 0) {
            payload.queue_id = 0;
        } else if (normalizedQueueIds.length === 1) {
            payload.queue_id = normalizedQueueIds[0];
        }

        await api.post(`api/users/${this.state.userId}/predefinedmessages/`, payload).then(async (res) => {
            if (res.status === 201) {
                data = res.data;

                useNotification(
                    'Sucesso!',
                    'Mensagem predefinida cadastrada com sucesso.',
                    'success'
                );

                // Refresh the grouped predefined messages from server to keep
                // a consistent state (enterprise + user messages)
                await this.fetchPredefinedMessages();
            }

            else if (res.status === 400) {
                useNotification(
                    'Houve um problema!',
                    res.data,
                    'danger'
                );
            }
        }).catch(async (err) => {
            console.error(err);
        });

        return data;
    }

    updatePredefinedMessage = (message) => {
        api.patch(`api/users/${this.state.userId}/predefinedmessages/${message.id}/`, {
            message: message.message
        }).then((res) => {
            if (res.status === 200) {
                useNotification(
                    'Sucesso!',
                    'Mensagem predefinida alterada com sucesso.',
                    'success'
                );
            }
        }).catch((err) => {
            console.error(err);
        });
    }

    removePredefinedMessage = (message) => {
        api.delete(`api/users/${this.state.userId}/predefinedmessages/${message.id}/`)
            .then((res) => {
                if (res.status === 204) {
                    // Remove message from grouped categories
                    const updated = { ...this.state.predefinedMessages };
                    Object.keys(updated).forEach((cat) => {
                        if (!Array.isArray(updated[cat])) return;
                        updated[cat] = updated[cat].filter((m) => m.id !== message.id);
                        if (updated[cat].length === 0) delete updated[cat];
                    });
                    this.setState({ predefinedMessages: updated });
                    useNotification(
         'success'
                );
            }
        }).catch((err) => {
            console.error(err);
        });
    }

    removePredefinedMessage = (message) => {
        api.delete(`api/users/${this.state.userId}/predefinedmessages/${message.id}/`)
            .then((res) => {
                if (res.status === 204) {
                    const predefinedMessages = this.state.predefinedMessages;
                    for (var i = 0; i < predefinedMessages.length; i++) {
                        if (predefinedMessages[i].id == message.id) {
                            predefinedMessages.splice(i, 1);
                        }
                    }
                    this.setState({
                        predefinedMessages: predefinedMessages
                    });
                    useNotification(
                        'Sucesso!',
                        'Mensagem predefinida excluída com sucesso.',
                        'success'
                    );
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }

    deleteCategory = async (category) => {
        try {
            const res = await api.delete(`api/users/${this.state.userId}/predefinedmessages/category/${encodeURIComponent(category)}/`);
            if (res.status === 204) {
                
                const predefinedMessages = { ...this.state.predefinedMessages };
                delete predefinedMessages[category];
                
                this.setState({
                    predefinedMessages: predefinedMessages
                });
                
                useNotification(
                    'Sucesso!',
                    `Categoria "${category}" excluída com sucesso.`,
                    'success'
                );
            }
        } catch (err) {
            console.error(err);
            useNotification(
                'Erro!',
                'Ocorreu um erro ao excluir a categoria.',
                'danger'
            );
        }
    }

    fetchHistoryMessages = (row) => {
        api.get(`/api/LHC/chats/${row.hash}/`)
            .then((res) => {
                if (res.status == 200) {
                    let state = {
                        historyChat : res.data,
                        showChatHistory: true,
                        historyMessages: res.data.messages,
                        platform: res.data.platform,
                        uniqueId: row.uniqueid,
                        lastDateTime: res.data.time
                    };
                    if (this.props.isManageCalls) {
                        state.showModal = false;
                    }
                    this.setState(state);
                    return;
                }
                throw res;
            })
            .catch((err) => {
                console.error(err);
            });
    }

    setActiveTab = (tab) => {
        this.setState({ activeTab: tab });
    }

    setActiveSubTab = (tab) => {
        this.setState({ activeSubTab: tab });
        this.context.setActiveChat({})
    }

    setActiveChat = (chat) => {
        if (Object.keys(chat).length === 0 && this.state.socket !== null)
            this.closeWebSocket();
        else
            this.connectWebSocket(chat);

        this.context.setActiveChat(chat)
        
        this.setState({
            showChatRightSideBar: false,
            profileContent: null
        });
    }

    updateChatListLastMessage = (message) => {
        const channel = this.context.activeChat?.channel || this.context.activeChat?.hash

        if (!channel || !message || message.message === 'PONG')
            return

        this.setState({
            chatListLastMessage: {
                channel: channel,
                message: { ...message },
                updatedAt: Date.now()
            }
        })
    }

    connectWebSocket = (activeChat) => {
        
        this.closeWebSocket(); // Close any existing socket

        let channel = activeChat?.lhc?.hash

        if (!channel){
            channel = (activeChat)
            ? activeChat.channel
            : this.context.activeChat.channel
        ;
        }

        if (!channel) return; // Avoid opening undefined socket connections

        const hs = window.location.hostname;

        window?.blockChat && window.blockChat(true)

        let socket = new WebSocket(`wss://${hs}/chat/ws/chat/${channel}/`);

        activeChat.socket = socket    
        
        let that = this;
        let keepAlive = null;

        socket.onopen = (e) => {
            window?.blockChat && window.blockChat(false)
            keepAlive = setInterval(() => {
                // If server not responding for more than 30 seconds
                // the connection might have been closed somewhere
                // we need to close and reopen a new websocket connection
                let curTime = new Date().getTime();
                if (that.state.lastSocketResponse && curTime - that.state.lastSocketResponse > 20000) {
                    socket.close();
                    that.refreshActiveChat();
                    that.connectWebSocket();
                    return;
                }

                // Pinging server every 20secs
                socket.send(JSON.stringify({
                    user: '0',
                    message: 'PING'
                }));
            }, 20000);
        }

        socket.onmessage = (e) => {

            const data = JSON.parse(e.data);

            // Handling websocket reations
            if (typeof data.message === "string" && data.message.startsWith(";REACTION;")) {
                const [,, messageId, reaction] = data.message.split(";")
                if (messageId && reaction) {
                    this.messageArea.children.messageArea.handleAddReaction(messageId, reaction)
                    return
                }
            }

            const curDate = new Date();
            const [hour, minutes] = curDate.toTimeString().split(':', 2)
            const curTime = Math.floor(Date.now() / 1000);

            that.lastSocketResponse = new Date().getTime()

            let message = {
                message    : data.message,
                iso_time   : hour + ':' + minutes,
                user_id    : parseInt(data.user),
                time       : curTime,
                reply_from : data.reply_from,
                message_id : data.message_id,
                id         : data.message_id,
            };

            if (message.user_id > 0)
                return

            const infinite_scroll_messages = this.messageArea?.children?.messageArea?.messages
            const normal_messages = this.messageArea?.children?.state?.messages
            let messages = (infinite_scroll_messages || normal_messages)

            // let messages = that.state.activeChat.messages;
            if (!messages) return;

            if (message.user_id === 0 && message.message !== 'PONG') {
                if (document.hidden) {
                    // deprecated !
                    // const audio = new Audio(`${window.location.origin}/new_message.mp3`)
                    // audio.play().catch(() => {})
                    // setFaviconBadge("message", true)
                    // setTimeout(() => setFaviconBadge("message", false), 5000)
                }
                that.context.activeChat.last_user_msg_time = curTime
            }

            if ('reloadMessageArea' in window) window.reloadMessageArea(messages)

            // Received duplicated message
            // When a message is sent, the request responds and another websocket 
            // comes back with the same message since it's broadcasted to all 
            // other users therefore we should only update the iso_time here
            if (message.user_id == -2) {
                const realData = JSON.parse(message.message)
                message = realData
                message.time = curTime
                message.iso_time = hour + ':' + minutes
                this.updateChatListLastMessage(message)

                if (infinite_scroll_messages) {
                    this.messageArea.children.messageArea.handleAddNewMessage(message)
                    return
                }
                const oldMessage = messages.find(each => each.id === message.id)
                if (oldMessage) {
                    oldMessage.time = message.time
                    oldMessage.iso_time = message.iso_time
                    messageArea?.current?.children.handleAddMessage()
                    return
                }
            }

            // Received signal from supervisor
            // This is used in order to update supervised messages status
            else if (message.user_id == -3) {

                const realData = JSON.parse(message.message)
                const oldMessage = messages.find(each => each.id == realData.id)
                oldMessage.status = realData.status
                oldMessage.time = curTime
                oldMessage.iso_time = hour + ':' + minutes
                if (infinite_scroll_messages) {
                    this.messageArea.children.messageArea.handleAddNewMessage(oldMessage)
                    return
                }
                this.messageArea.children.handleAddMessage()
                return
            }

            // Received drop_chat from transfer
            // This is used in order to drop chat from all other users who
            // have it opened, since it has been transferred
            else if (message.user_id == -4) {
                const realData = JSON.parse(message.message)
                if ('chatID' in realData && realData.chatID == that.context.activeChat.id) {
                    this.closeChat()
                    useNotification(
                        'Informação',
                        `O chat foi transferido para a fila ${realData.queue} por ${realData.actor}.`,
                        'info'
                    );
                }
                return
            }

            // Received drop_chat from hangup
            // This is used in order to drop chat from all other users who
            // have it opened, since it has been hanged up
            else if (message.user_id == -5) {
                try {
                    const realData = JSON.parse(message.message)
                    if ('chatID' in realData && realData.chatID == that.context.activeChat.id) {
                        this.closeChat()
                        useNotification(
                            'Informação',
                            `O chat foi finalizado por ${realData.actor}.`,
                            'info'
                        );
                    }   
                } catch { /* In some cases message is not an object */ }
                return
            }

            // Received message sent signal
            // This signal is used in order to update the message's channel id
            // to future references as soon as it's sent to the end user
            else if (message.user_id == -6) {
                const messageObj = messages.find(each => each.id === message.message.id)
                messageObj.message_id = message.message.message_id
                if (infinite_scroll_messages) {
                    this.messageArea.children.messageArea.handleAddNewMessage(messageObj)
                }
                return
            }

            // Received read signal
            // This signal is used in order to show that a message has been
            // read by the end client
            if (message.user_id == -7) {
                const currMessage = messages.find(each => each.message_id == data.message)
                if (currMessage) {
                    currMessage.is_client_read = true
                    if (infinite_scroll_messages) {
                        this.messageArea.children.messageArea.handleAddNewMessage(currMessage)
                    }
                }
                return
            }

                        // Received drop_chat from hangup
            // This is used in order to drop chat from all other users who
            // have it opened, since it has been hanged up
            else if (message.user_id == -8) {
                try {
                    const realData = JSON.parse(message.message)
                    if ('chatID' in realData && realData.chatID == that.context.activeChat.id) {
                        if (UserPermissions().isSupervisor){
                            that.context.activeChat.chatstatus = 'ONCHAT';
                        } else 
                            this.closeChat()
                        
                        useNotification(
                            'Informação',
                            `O chat foi atendido por ${realData.actor}.`,
                            'info'
                        );
                    }   
                } catch { /* In some cases message is not an object */ }
                return
            }

            // let lastMessage = messages[messages.length - 1];
            // if (!that.isSameMessage(lastMessage, message) && message.message != 'PONG') {
            if (message.message != 'PONG') {
                this.updateChatListLastMessage(message)
                this.messageArea.children.handleAddMessage(message)
                if (this.messageArea.children.shouldRefresh()) {
                    that.context.activeChat.messages = [...messages, message]
                    that.context.setActiveChat({ ...that.context.activeChat })
                }  
            }

            // }

            // Doing this will rerrender everything
            // let activeChat = that.context.activeChat;
            // activeChat.messages = [...activeChat.messages, message];
        };

        socket.onclose = (e) => {
            window?.blockChat && window.blockChat(false)
            clearInterval(keepAlive);
            that.state.lastSocketResponse = null;
        };

        this.state.socket = socket;
    }    

    isSameMessage = (message1, message2) => {
        return message1.user_id == message2.user_id &&
            message1.message == message2.message
    }

    closeWebSocket = () => {
        if (this.state.socket) {
            this.state.socket.close();
        }
        this.state.socket = null;
    }

    addOngoingChat = (chat) => {

        this.setUpdateList()
        // if (window.innerWidth > 960) {
        //     // Avoiding mobile error
        //     this.conversationList.addOngoingChat(chat);   
        // }
    }

    addReactivatedChat = (chat) => {
        this.setUpdateList()
        // this.conversationList.addReactivatedChat(chat);
    }

    removeOngoingChat = (chat) => {
        this.setUpdateList()
        // this.conversationList.removeOngoingChat(chat);
    }

    showChatRightSideBar = (contact) => {
        // Allow toggle in both column and overlay modes (>= 960px)
        // Block only on true mobile (< 960px)
        if (window.innerWidth >= 960) {
            this.setState({
                showChatRightSideBar: !this.state.showChatRightSideBar,
                contactData: contact,
            });
        }
    }

    closeProfile = () => {
        this.setState({
            showProfile: false,
            contactData: {},
            renderKey: Math.random()
        });
    }

    resetActiveChatProgress = () => {
        this.setUpdateList()
        // this.conversationList.resetActiveChatProgress();
    }

    refreshActiveChat = () => {
        this.setUpdateList()
        // ;
        // this.conversationList.refreshActiveChat();
    }

    isManageCalls = () => {
        return this.props.isManageCalls;
    }

    notIsManageCalls = () => {
        return !this.props.isManageCalls;
    }

    lastDateTime = () => {
        return (this.context.activeChat.chatstartts || this.context.activeChat.time) * 1000;
    }

    openChat = (chat) => {
        this.setState({ showModal: true });
        this.context.setActiveChat(chat)
    }

    closeChat = () => {
        this.setState({
            showModal: false,
            showProfile: false,
            renderKey: Math.random(),
            showChatRightSideBar: false
        });
        this.context.setActiveChat({})
    }

    handleCloseHistoryMessages = () => {
        let state = {
            showChatHistory: false
        };
        if (this.props.isManageCalls) {
            state.showModal = true;
        }
        this.setState(state);
    }

    updateMessages = (message, index, status) => {
        //this.forceUpdate();
        // const activeChat = this.context.activeChat;
        // this.setState({ activeChat: activeChat });
    }

    setUpdateList = (target) => {
        this.setState({ updateList: !this.state.updateList })
    }

    connectEmailChat = () => {
        this.messageArea.children.connectActiveChat()
    }

    buildChatList = () => {
        if (!this.state.ready)
            return (
                <Box id="conversationList-box-4">
                    <CircularProgress />
                </Box>
            )

        return (

            <NewConversationList
                enterpriseId={this.state.enterpriseId}
                agentId={this.state.agentId}
                activeTab={this.state.activeTab}
                setActiveTab={this.setActiveTab}
                activeSubTab={this.state.activeSubTab}
                setActiveSubTab={this.setActiveSubTab}
                activeChat={this.context.activeChat}
                setActiveChat={this.setActiveChat}
                connectEmailChat={this.connectEmailChat}
                closeProfile={this.closeProfile}
                openChat={(chat) => this.openChat(chat)}
                isManageCalls={this.props.isManageCalls}
                setReadMessages={this.setReadMessages}
                notificationAudio={this.state.notificationAudio}
                key={this.state.renderKeyList}
                refresh={() => { this.setState({ refresh: !this.state.refresh }) }}
                refreshChat={() => { this.messageArea?.children?.refreshChat() }}
                loading={this.state.loading}
                labels={this.state.chatLabels}
                updateList={this.state.updateList}
                latestMessage={this.state.chatListLastMessage}
                allGroups={this.state.allGroups}
            />
        );
    }

    buildMessageArea = () => {
        return (
            <>
                {this.state.showChatHistory &&
                    <HistoryMessagesDialog
                        activeChat={this.state.historyChat}
                        open={this.state.showChatHistory}
                        uniqueId={this.state.uniqueId}
                        nick={this.state.contactData ? this.state.contactData.nick : null}
                        lastDateTime={this.state.lastDateTime}
                        historyMessages={this.state.historyMessages}
                        platform={this.state.platform}
                        accountcode={this.state.accountcode}
                        handleClose={() => this.handleCloseHistoryMessages()}
                    />
                }
                <ErrorBoundary
                  componentName="MessagesArea"
                  title="Ops"
                  message="Algo deu errado, mas já fomos informados e estamos cuidando disso."
                  showReset={true}
                  logToBackend={true}
                >
                    <MessagesArea
                        ref={
                            instance => {
                                this.messageArea = instance
                            }
                        }
                        activeChat={this.context.activeChat}
                        activeTab={this.state.activeTab}
                        activeSubTab={this.state.activeSubTab}
                        setActiveChat={this.setActiveChat}
                        setActiveTab={this.setActiveTab}
                        setActiveSubTab={this.setActiveSubTab}
                        agentId={this.state.agentId}
                        enterpriseId={this.state.enterpriseId}
                        addOngoingChat={this.addOngoingChat}
                        addReactivatedChat={this.addReactivatedChat}
                        removeOngoingChat={this.removeOngoingChat}
                        predefinedMessages={this.state.predefinedMessages}
                        addPredefinedMessage={this.addPredefinedMessage}
                        updatePredefinedMessage={this.updatePredefinedMessage}
                        removePredefinedMessage={this.removePredefinedMessage}
                        deleteCategory={this.deleteCategory}
                        accountcode={this.state.accountcode}
                        showChatRightSideBar={this.showChatRightSideBar}
                        connectWebSocket={this.connectWebSocket}
                        closeWebSocket={this.closeWebSocket}
                        resetActiveChatProgress={this.resetActiveChatProgress}
                        enterpriseQueues={this.state.enterpriseQueues}
                        contactData={this.state.contactData}
                        renderKey={this.state.renderKey}
                        key={this.state.renderKey}
                        templates={this.state.templates}
                        isManageCalls={this.props.isManageCalls}
                        closeModal={() => this.closeChat()}
                        updateMessages={this.updateMessages}
                        setReadMessages={this.setReadMessages}
                        connections={this.props.connections}
                        setChatLabels={this.setChatLabels}
                        profileContent={this.state.profileContent}
                        setProfileContent={(value, then) => {
                            if (this.state.profileContent !== value) {
                                console.debug('[cortex-sidebar] setProfileContent %o -> %o, reopening', this.state.profileContent, value)
                                this.setState({ profileContent: value, showChatRightSideBar: false }, () => then())
                            } else {
                                console.debug('[cortex-sidebar] setProfileContent skipped, already %o (showChatRightSideBar=%o)', value, this.state.showChatRightSideBar)
                            }
                        }}
                    />
                </ErrorBoundary>
            </>
        );
    }

    buildProfile = () => {
        return (
            <Profile
                showProfile={this.state.showProfile}
                contactData={this.state.contactData}
                closeProfile={() => this.setState({ showProfile: false })}
                isManageCalls={this.props.isManageCalls}
                fetchHistoryMessages={(row) => this.fetchHistoryMessages(row)}
                agentCanUpdateContact={this.agentCanUpdateContact}
            />
        );
    }

    reloadContact = () => {
        this.messageArea.children.reloadContact()
    }

    buildChatRightSideBar = () => {
        return (
            <ChatRightSideBar
                agentCanUpdateContact={this.agentCanUpdateContact}
                contactData={this.state.contactData}
                enterprise={this.state.enterpriseId}
                closeChatRightSideBar={() => this.setState({ 
                    profileContent: null,
                    showChatRightSideBar: false 
                })}
                isManageCalls={this.props.isManageCalls}
                fetchHistoryMessages={(row) => this.fetchHistoryMessages(row)}
                allLabels={this.state.allLabels}
                chatLabels={this.state.chatLabels}
                setChatLabels={this.setChatLabels}
                chat={this.context.activeChat}
                reloadContact={this.reloadContact}
                chatCursor={this.messageArea?.children?.messageArea?.chatCursor}
                allGroups={this.state.allGroups}
                setChatGroups={this.setChatGroups}
                parent={{templates:this.state.templates, queues: this.state.enterpriseQueues}}
                fetchScoutMessages={(row) => {
                    const url = '/scout?account=' + row.owner + '&chat=' + row.id;
                    window.location = url;
                }}
                profileContent={this.state.profileContent}
            />
        );
    }

    buildManageCalls = () => {
        return (
            <Box className="manage-calls">
                <ModalMessagesArea
                    open={this.state.showModal}
                    handleClose={() => this.closeChat()}
                    buildMessageArea={this.buildMessageArea}
                    buildProfile={this.buildChatRightSideBar()}
                    showProfile={this.state.showChatRightSideBar}
                    key={this.state.renderKey}
                />
                {this.buildChatList()}
            </Box>
        );
    }

    checkScreenSize = () => {
        const isOverlay = window.innerWidth < OVERLAY_MODE_BREAKPOINT;
        if (this.state.isOverlayMode !== isOverlay) {
            if (isOverlay && this.state.showChatRightSideBar)
                console.debug('[cortex-sidebar] checkScreenSize auto-closing sidebar, resetting profileContent (was %o)', this.state.profileContent)
            this.setState({
                isOverlayMode: isOverlay,
                // Auto-close sidebar when switching to overlay mode
                // Also reset profileContent so it doesn't go stale (see setProfileContent guard)
                showChatRightSideBar: isOverlay ? false : this.state.showChatRightSideBar,
                profileContent: isOverlay ? null : this.state.profileContent
            });
        }
    }

    handleEscapeKey = (event) => {
        if (event.key === 'Escape' && this.state.showChatRightSideBar && this.state.isOverlayMode) {
            console.debug('[cortex-sidebar] Escape closing sidebar, resetting profileContent (was %o)', this.state.profileContent)
            this.setState({ showChatRightSideBar: false, profileContent: null });
        }
    }

    async componentWillMount() {
        this.setState({ loading: true })
        const user = getSession();

        if (user) {
            this.state.userId = user.id;
            this.state.agentId = user.profile.agent_id;
            this.state.enterpriseId = user.profile.enterprise.id;
            this.state.agentUser = user.profile.agent.user;
        }
        await this.fetchEnterprise();
        await this.fetchPredefinedMessages();
        await this.fetchTemplates();
        this.setState({ loading: false })
        await this.getLabels();

        // Deprecated, the correct component handles this now
        // if (user.profile.enterprise.show_chat_groups)
        //     await this.getGroups();

        window.reloadChat = () => {
            this.context.activeChat.contact = this.state.contactData
            this.setState({ contactData: {...this.state.contactData} })
            this.context.setActiveChat(this.context.activeChat)
        }

        // Initialize screen size detection
        this.checkScreenSize();
        window.addEventListener('resize', this.checkScreenSize);
        document.addEventListener('keydown', this.handleEscapeKey);

        this.setState({ ready: true })
    }

    componentWillUnmount() {
        this.closeWebSocket();

        // Clean up event listeners
        window.removeEventListener('resize', this.checkScreenSize);
        document.removeEventListener('keydown', this.handleEscapeKey);

        window.reloadChat = () => {}

        this.context.setActiveChat({})
    }

    setReadMessages = (messages) => {
        if (messages.length === 0)
            return;

        // Setting unreadMessages is_read
        const unreadMessagesIds = messages.filter(each => !each.is_read).map(m => m.id).filter(id => id);

        if (unreadMessagesIds.length === 0)
            return;

        api.post('/api/LHC/messages/set_read/', {
            messages: unreadMessagesIds
        }).then((res) => {
            if (res.status === 200)
                return;
            throw res;
        }).catch((err) => {
            console.error(err);
        });
    }

    shouldRenderChatList = () => {
        return !isMobile() || (
            isMobile() &&
            Object.keys(this.context.activeChat).length === 0 &&
            Object.getPrototypeOf(this.context.activeChat) === Object.prototype
        );
    }

    shouldRenderMessageArea = () => {
        return !isMobile() || (
            isMobile() &&
            Object.keys(this.context.activeChat).length !== 0 &&
            Object.getPrototypeOf(this.context.activeChat) === Object.prototype
        );
    }

    getLabels = async () => {

        await api.get(`api/enterprises/${this.state.enterpriseId}/labelchat/`)
            .then((res) => {
                if (res.status === 200) {
                    this.setState({
                        allLabels: res.data
                    })
                }
                if (res.status === 404) {
                    if ('detail' in res.data && res.data.detail == 'Not found.') {
                        useNotification(
                            'Não encontradas!',
                            'Etiquetas não encontradas.',
                            'danger'
                        );
                    }
                }
                return;
            })
            .catch((err) => {
                console.error(err);
            });
    }

    getGroups = async () => {
        const response = await api.get(`api/enterprises/${this.state.enterpriseId}/contact_group/noserialize/`)
        if (response.status === 200)
            this.setState({ allGroups: response.data.results })
    }

    setChatLabels = (labels) => {
        this.setState({
            chatLabels: labels
        })
    }

    setChatGroups = (chat) => {
        this.setState({ refresh: ! this.state.refresh })
    }

    render() {
        const { isOverlayMode, showChatRightSideBar } = this.state;

        return (
            <Box className="kwik-main-chat">
                {/* <ReactNotifications /> */}
                <Grid container>
                    {this.notIsManageCalls() &&
                        <>
                            <Grid
                                style={{
                                    display: this.shouldRenderChatList() ? 'flex' : 'none',
                                    minWidth: 0,
                                }}
                                item lg={3} md={3} sm={4} xs={4}
                                className="column-grid"
                            >
                                <Box className="conversationList-box">
                                    {this.buildChatList()}
                                </Box>
                            </Grid>

                            {this.shouldRenderMessageArea() &&
                                <Grid
                                    item lg={true} md={true} sm={true} xs={true}
                                    className="column-grid"
                                    style={{ minWidth: 0 }}
                                >
                                    <Box className="message-box">
                                        {this.buildMessageArea()}
                                    </Box>
                                </Grid>
                            }

                            {/* Sidebar in column mode */}
                            {showChatRightSideBar && !isOverlayMode &&
                                <Grid
                                    item lg={3} md={4} sm={4} xs={4}
                                    className="column-grid"
                                    style={{ minWidth: 0 }}
                                >
                                    {this.buildChatRightSideBar()}
                                </Grid>
                            }
                        </>
                    }
                    {this.isManageCalls() &&
                        <>
                            {this.buildManageCalls()}
                        </>
                    }
                </Grid>

                {/* Backdrop for overlay mode */}
                {showChatRightSideBar && isOverlayMode &&
                    <Box
                        className="chat-sidebar-backdrop"
                        onClick={() => {
                            console.debug('[cortex-sidebar] backdrop click closing sidebar, resetting profileContent (was %o)', this.state.profileContent)
                            this.setState({ showChatRightSideBar: false, profileContent: null })
                        }}
                    />
                }

                {/* Sidebar in overlay mode (< 1440px) */}
                {showChatRightSideBar && isOverlayMode &&
                    <Box className={`chat-sidebar-overlay ${showChatRightSideBar ? 'open' : ''}`}>
                        {this.buildChatRightSideBar()}
                    </Box>
                }
            </Box>
        );
    }
}

export default Chat;
